import { useTranslation } from 'react-i18next';

import { Box, Chip } from '@mui/material';

type Weekdays = {
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
};

type Props = {
  value: Weekdays;
  onChange: (weekdays: Weekdays) => void;
};

export default function WeekdaysPicker(props: Props) {
  const { value, onChange } = props;
  const { t } = useTranslation();

  const handleClick = (day: 'MO' | 'TU' | 'WE' | 'TH' | 'FR' | 'SA' | 'SU') => {
    const newWeekdays = value;
    switch (day) {
      case 'MO':
        newWeekdays.monday = !newWeekdays.monday;
        break;
      case 'TU':
        newWeekdays.tuesday = !newWeekdays.tuesday;
        break;
      case 'WE':
        newWeekdays.wednesday = !newWeekdays.wednesday;
        break;
      case 'TH':
        newWeekdays.thursday = !newWeekdays.thursday;
        break;
      case 'FR':
        newWeekdays.friday = !newWeekdays.friday;
        break;
      case 'SA':
        newWeekdays.saturday = !newWeekdays.saturday;
        break;
      case 'SU':
        newWeekdays.sunday = !newWeekdays.sunday;
        break;
    }
    onChange(newWeekdays);
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.mo')}
        onClick={() => handleClick('MO')}
        color={value.monday ? 'primary' : 'default'}
      />
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.tu')}
        onClick={() => handleClick('TU')}
        color={value.tuesday ? 'primary' : 'default'}
      />
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.we')}
        onClick={() => handleClick('WE')}
        color={value.wednesday ? 'primary' : 'default'}
      />
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.th')}
        onClick={() => handleClick('TH')}
        color={value.thursday ? 'primary' : 'default'}
      />
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.fr')}
        onClick={() => handleClick('FR')}
        color={value.friday ? 'primary' : 'default'}
      />
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.sa')}
        onClick={() => handleClick('SA')}
        color={value.saturday ? 'primary' : 'default'}
      />
      <Chip
        clickable
        size="small"
        sx={{ width: 40 }}
        label={t('weekday.su')}
        onClick={() => handleClick('SU')}
        color={value.sunday ? 'primary' : 'default'}
      />
    </Box>
  );
}
